import React from 'react'
import LinkedinLogo from '../assets/svg/linkedin.svg'
import TwitterLogo from '../assets/svg/twitter.svg'
import FacebookLogo from '../assets/svg/facebook.svg'
import YoutubeLogo from '../assets/svg/youtube.svg'
const CopyrightFooter = (props) => {
    return (
        <footer className={`flex justify-between pt-5  ${props.fixedBottom ? "fixed px-10 pb-5" : ""} bottom-0 w-full left-0`}>
                {/* <a href="https://www.viewprogis.com" target="_blank" rel="noreferrer" className="absolute left-0 ml-10">Go to www.viewprogis.com >>></a> */}
                <div className="opacity-75">© Copyright 2020 ViewPro. All rights reserved.</div> 
                <div className="flex justify-end space-x-4 items-center">
                    <a href="https://www.linkedin.com/company/viewprogis" rel="noopener noreferrer" target="_blank"><img src={LinkedinLogo} alt="" /></a>
                    <a href="https://twitter.com/viewprogis" rel="noopener noreferrer" target="_blank"><img src={TwitterLogo} alt="" /></a>
                    <a href="https://www.facebook.com/viewprogis" rel="noopener noreferrer" target="_blank"><img src={FacebookLogo} alt="" /></a>
                    <a href="https://www.youtube.com/watch?v=FN6lN4Bp8m4&t=7s" rel="noopener noreferrer" target="_blank"><img src={YoutubeLogo} alt="" /></a>
                </div>
                {/* <Link to="/privacy-policy" className="absolute right-0 mr-10">Privacy Policy</Link>    */}
            </footer>
    )
}

export default CopyrightFooter
